module.exports = __webpack_public_path__ + "static/img/logo_red_education.7c9a80c9.png";